'use strict';

(function ($, FUNCTIONS, cssua) {
	var a = 'is-active';
	var f = 'is-fixed';
	var v = 'is-visible';
	var slideSpeed = '400';

	FUNCTIONS = {
		slides: function slides() {
			if ($('.idx').length) {
				$('.idx-slide01').slick({
					arrows: true,
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true,
					centerPadding: '20%',
					loop: true,
					infinite: true,
					dots: true,
					responsive: [{
						breakpoint: 768,
						settings: {
							centerPadding: '10%'
						}
					}]
				});
			}
		},
		animation: function animation() {
			// スライダー用アニメーション
			if ($('.js-inview-slide').length) {
				$('.js-inview-slide').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
						$('.idx-slide01').slick('slickPlay');
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}

			// 下からアニメーション
			if ($('.js-inview-bottom').length) {
				$('.js-inview-bottom').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
			// 左からアニメーション
			if ($('.js-inview-left').length) {
				$('.js-inview-left').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}

			// 右からアニメーション
			if ($('.js-inview-right').length) {
				$('.js-inview-right').waypoint(function (direction) {
					var activePoint = $(this.element);
					if (direction === 'down') {
						// scroll down
						activePoint.addClass(a);
					} else {
						// scroll up
						activePoint.removeClass(a);
					}
				}, { offset: '70%' });
			}
		},
		modal: function modal() {
			var scrollTopNow;
			$('.js-modal-btn').on('click', function (event) {
				var imgs = $(this).find('img').attr('src');
				console.log(imgs);
				$('.js-modal-overlay').addClass(a);
				$('.js-modal-content').html('<img src="' + imgs + '" class="width-u-100">');
				scrollTopNow = $(window).scrollTop();
				$('body').addClass(f);
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				event.preventDefault();
			});
			$('.js-modal-closeBtn').on('click', function (event) {
				$('.js-modal-content').html('');
				$('.js-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$('.container').css({
					position: 'static'
				});
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});

			$('.js-modal-back').on('click', function (event) {
				$('.js-modal-content').html('');
				$('.js-modal-overlay').removeClass(a);
				$('body').removeClass(f);
				$('.container').css({
					position: 'static'
				});
				$(window).scrollTop(scrollTopNow);
				event.preventDefault();
			});
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.slides();
			_this.animation();
			_this.modal();
		}
	};

	$(function () {
		return FUNCTIONS.loadDelayScript();
	});
})(window.jQuery, window.FUNCTIONS, window.cssua);